import { render } from "./CateEditModal.vue?vue&type=template&id=138297f0&scoped=true"
import script from "./CateEditModal.vue?vue&type=script&lang=js"
export * from "./CateEditModal.vue?vue&type=script&lang=js"

import "./CateEditModal.vue?vue&type=style&index=0&id=138297f0&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138297f0"]])

export default __exports__